$(document).ready(function() {
	if ($('img[usemap]').length) {
		$('img[usemap]').imageMap();
		$('area').each(function() {
			$(this).hover(
				function() {
					$('#' + $(this).attr("data-id") + '').addClass('hover');
				},
				function() {
					$('#' + $(this).attr("data-id") + '').removeClass('hover');
				})
		})
	}
});